<template>
  <section
    class="section-chechout"
    id="menu-section"
    v-if="cart"
    v-loading.fullscreen.lock="processing"
    element-loading-background="rgba(256, 256, 256, 0.6)"
  >
    <component :is="'style'">
      .text{ background-color:{{ myTheme.topMenu.normal.backgroundColor }};
      color:{{ myTheme.topMenu.normal.color }}; } .active-selected-card{
      color:{{ myTheme.topMenu.normal.backgroundColor }}; font-size:20px }
    </component>
    <div class="container">
      <div class="row">
        <div class="col-md-6 ml-auto col-xl-6 mr-auto">
          <b-alert v-model="showEmailAlert" variant="danger" dismissible>{{
            this.emailExist
          }}</b-alert>
          <cards>
            <tabs
              :itemStyle="myTheme.customizeButton"
              class="checkout-tabs"
              slot="raw-content"
              tab-content-classes="tab-content-padding"
              v-model="orderCompleted.step"
            >
              <tab-pane
                :disabled="orderCompleted.step > enumHelper.steps.STEP02"
                label="Step01"
              >
                <div slot="label" class="text-center">
                  <i class="now-ui-icons k-icon-account"></i>
                  {{ $t("text.step_01") }}
                </div>
                <div class="section-steps-1">
                  <div class="container">
                    <div class="row">
                      <cards class="card-step1" header-classes="text-center">
                        <template slot="header">
                          <div class="social-line"></div>
                        </template>
                        <template>
                          <div class="form-group input-group" v-if="!user">
                            <p class="p-login">
                              {{ $t("text.already_have_an_account") }}
                              <router-link class="url-color" to="/login?redirect=checkout">{{
                                $t("text.login_here")
                              }}</router-link>
                            </p>
                          </div>
                          <fg-input
                            :disabled="user && user.id"
                            class="no-border"
                            :class="{
                              'has-danger': errors.firstName,
                              'has-success': errors.firstName === false,
                            }"
                            :placeholder="$t('input.placeholder.first_name')"
                            addon-left-icon="now-ui-icons users_circle-08"
                            v-model.lazy="cart.user.first_name"
                          ></fg-input>

                          <fg-input
                            :disabled="user && user.id"
                            class="no-border"
                            :class="{
                              'has-danger': errors.lastName,
                              'has-success': errors.lastName === false,
                            }"
                            :placeholder="$t('input.placeholder.last_name')"
                            addon-left-icon="now-ui-icons text_caps-small"
                            v-model.lazy="cart.user.last_name"
                          ></fg-input>

                          <fg-input
                            :disabled="user && user.id"
                            class="no-border"
                            :class="{
                              'has-danger': errors.email,
                              'has-success': errors.email === false,
                            }"
                            :placeholder="$t('input.placeholder.email')"
                            addon-left-icon="now-ui-icons ui-1_email-85"
                            v-model.lazy="cart.user.email"
                          ></fg-input>

                          <fg-input
                            :disabled="user && user.id"
                            class="no-border"
                            :class="{
                              'has-danger': errors.phoneNumber,
                              'has-success': errors.phoneNumber === false,
                            }"
                            :placeholder="
                              $t('input.placeholder.contact_number')
                            "
                            addon-left-icon="now-ui-icons k-icon-phone"
                            v-model.lazy="cart.user.telephone_number"
                          ></fg-input>
                          <!---------------Start Table Selection---------------->
                          <div
                            v-if="cart.orderType == enumHelper.orderType.Table"
                            class="table-ordering form-group input-group"
                          >
                            <template>
                              <el-select
                                v-model="table_id"
                                :class="{
                                  'has-danger': errors.table,
                                  'has-success': errors.table === false,
                                }"
                                :placeholder="
                                  $t('input.placeholder.select_table')
                                "
                                @change="OnTableChanged"
                              >
                                <el-option
                                  v-for="(
                                    table, index
                                  ) in selectedLocation.tables"
                                  :key="index"
                                  :label="table.name"
                                  :value="table.id"
                                >
                                  <span style="float: left">
                                    {{ table.name }}
                                  </span>
                                  <span
                                    style="
                                      float: right;
                                      color: #8492a6;
                                      font-size: 13px;
                                    "
                                    >{{ $t("text.capacity") }} :
                                    {{ table.capacity }}</span
                                  >
                                </el-option>
                              </el-select>
                            </template>
                          </div>
                          <!---------------End Table Selection---------------->

                          <!---------------Start Coupon Status---------------->
                          <div
                            class="form-group input-group"
                            v-if="isAuthenticated && couponStatus"
                          >
                            <el-alert
                              :title="couponStatus.title"
                              :type="couponStatus.type"
                              :closable="false"
                            ></el-alert>
                          </div>
                          <!---------------End Coupon Status---------------->
                          <!---------------Start pickupTime--------------->
                          <div
                            class="pickup-delivery"
                            v-if="cart.orderType != enumHelper.orderType.Table"
                          >
                            <div class="list-group-item">
                              <p class="title">
                                <span>
                                  {{
                                    cart.orderType ==
                                    enumHelper.orderType.Delivery
                                      ? $t("text.delivery")
                                      : cart.orderType ==
                                        enumHelper.orderType.Collection
                                      ? $t("text.collection")
                                      : ""
                                  }}
                                  {{ $t("text.time") }}
                                </span>
                              </p>
                              <div class="btn-group">
                                <n-radio-button
                                  v-if="displayASAPButton"
                                  :styleClass="myTheme.standardRadioButton"
                                  v-model="cart.pickUp.type"
                                  :label="enumHelper.PickupTime.ASAP"
                                  v-on:input="OnTimeChanged"
                                >
                                  {{
                                    $t("text.asap_estimation", {
                                      value:
                                        this.getOrderSettingsByType()
                                          .deliveryPickupTime,
                                    })
                                  }}</n-radio-button
                                >
                                <n-radio-button
                                  :styleClass="myTheme.standardRadioButton"
                                  v-model="cart.pickUp.type"
                                  :label="enumHelper.PickupTime.LATER"
                                  v-on:input="OnTimeChanged"
                                  >{{ $t("text.later") }}</n-radio-button
                                >
                              </div>
                              <div
                                class="datepicker-container"
                                v-if="
                                  cart.pickUp.type ==
                                  enumHelper.PickupTime.LATER
                                "
                              >
                                <div class="row">
                                  <div class="col-md-6">
                                    <fg-input
                                      inputClasses="select-read-only"
                                      class="no-border"
                                      :class="{
                                        'has-danger': errors.date,
                                        'has-success': errors.date === false,
                                      }"
                                    >
                                      <el-date-picker
                                        type="date"
                                        :clearable="false"
                                        :picker-options="datePickerOptions"
                                        popper-class="date-picker date-picker-primary"
                                        :placeholder="
                                          $t('input.placeholder.select_date')
                                        "
                                        v-model="cart.pickUp.date"
                                        value-format="yyyy-MM-dd"
                                        @change="onDateChanged"
                                      ></el-date-picker>
                                    </fg-input>
                                  </div>
                                  <div class="col-md-6">
                                    <fg-input
                                      class="no-border"
                                      :class="{
                                        'has-danger': errors.time,
                                        'has-success': errors.time === false,
                                      }"
                                    >
                                      <el-select
                                        v-model="cart.pickUp.time"
                                        :placeholder="
                                          $t('input.placeholder.select_time')
                                        "
                                      >
                                        <el-option
                                          v-for="(time, index) in timeOptions"
                                          :key="index"
                                          :label="time.name"
                                          :value="time.name"
                                          >{{ time.name }}</el-option
                                        >
                                      </el-select>
                                    </fg-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group input-group">
                            <div
                              v-if="
                                cart.pickUp.type ==
                                  enumHelper.PickupTime.LATER &&
                                cart.pickUp.date &&
                                cart.pickUp.time
                              "
                            >
                              <span class="title">{{ $t("text.time") }} :</span>
                              <span>{{ getDateTimeText(cart.pickUp) }}</span>
                            </div>
                          </div>
                          <!---------------End pickupTime--------------->
                          <!--------------- Start Display the delivery details : Select option for user , Adress input for guests--------------->
                          <div
                            class="pickup-delivery"
                            v-if="
                              cart.orderType == enumHelper.orderType.Delivery
                            "
                          >
                            <p class="title">
                              {{ $t("text.delivery_details") }}
                            </p>
                            <div
                              v-if="isAuthenticated"
                              class="form-group no-border"
                            >
                              <div class="input-group">
                                <div
                                  class="
                                    col-md-8
                                    romove-left-right-padding
                                    add-top-margin
                                  "
                                >
                                  <el-select
                                    v-model="address_id"
                                    :placeholder="
                                      $t('input.placeholder.Select_address')
                                    "
                                    @change="OnAddressChanged"
                                  >
                                    <el-option
                                      v-for="(address, index) in user.addresses"
                                      :key="index"
                                      :label="
                                        address.name || address.address_line_1
                                      "
                                      :value="address.id"
                                    >
                                      <span
                                        class="span-left"
                                        style="white-space: nowrap !important"
                                      >
                                        {{
                                          address.name || address.address_line_1
                                        }}
                                      </span>
                                      <span class="span-right">
                                        {{
                                          helpers.generateFromatedAddress(
                                            address,
                                            false
                                          )
                                        }}
                                      </span>
                                    </el-option>
                                  </el-select>
                                </div>
                                <div class="col-md-4 romove-left-right-padding">
                                  <n-button
                                    :style="myTheme.customizeButton"
                                    type="primary"
                                    @click="onAddNewAddress"
                                    round
                                    block
                                    >{{ $t("button.new_address") }}</n-button
                                  >
                                </div>
                              </div>
                              <div
                                class="required form-group input-group"
                                v-if="errors.address === true"
                              >
                                {{ $t("text.please_select_address") }}
                              </div>
                            </div>
                            <div v-else class="form-group no-border">
                              <address-lookup-form
                                :isNewAddress="isNewAddress"
                                :address="addressToEditData"
                                @updateAddress="setCartAddress"
                                :placeholderText="
                                  this.$t('input.placeholder.start_typing')
                                "
                              />
                            </div>
                            <div class="form-group" v-if="deliverFeeStatus">
                              <el-alert
                                :title="deliverFeeStatus.title"
                                :type="deliverFeeStatus.type"
                                :closable="false"
                              ></el-alert>
                            </div>
                          </div>
                          <!--------------- Start driver Instructions --------------->
                          <fg-textarea
                            v-if="
                              cart.orderType === enumHelper.orderType.Delivery
                            "
                            class="no-border"
                            maxlength="500"
                            :placeholder="
                              $t('input.placeholder.driver_instruction')
                            "
                            addon-left-icon="now-ui-icons ui-1_email-85"
                            v-model.lazy="cart.driver_instructions"
                          ></fg-textarea>
                          <!--------------- End driver Instructions --------------->
                          <!--------------- Start comment --------------->
                          <fg-textarea
                            class="no-border"
                            maxlength="500"
                            :placeholder="
                              $t('input.placeholder.your_comment_opt')
                            "
                            addon-left-icon="now-ui-icons ui-1_email-85"
                            v-model.lazy="cart.comment"
                          ></fg-textarea>
                          <!--------------- End comment --------------->
                          <!--------------- Start Agreement --------------->
                          <div class="form-group input-group">
                            <p class="agreement">
                              {{ $t("text.terms_conditions_1") }}
                              <strong>
                                <router-link
                                  class="url-color"
                                  to="/termsandconditions"
                                  >{{ $t("text.terms_conditions_2") }}
                                </router-link>
                              </strong>
                              {{ $t("text.terms_conditions_3") }}
                            </p>
                            <n-checkbox v-model="isAgree" style="width: 100%"
                              >Agree</n-checkbox
                            >
                            <p class="required" v-if="errors.agree === true">
                              {{ $t("validation.agree_required") }}
                            </p>
                          </div>
                          <!--------------- End Agreement --------------->
                        </template>
                      </cards>
                    </div>
                  </div>
                </div>
              </tab-pane>
              <tab-pane
                :disabled="orderCompleted.step != enumHelper.steps.STEP02"
                label="Step02"
              >
                <template slot="label">
                  <i class="now-ui-icons shopping_cart-simple"></i>
                  {{ $t("text.step_02") }}
                </template>
                <div class="section-steps-2">
                  <div class="container">
                    <div class="row">
                      <cards class="card-step2" header-classes="text-center">
                        <template slot="header">
                          <div class="social-line"></div>
                        </template>
                        <template>
                          <!---------------Start payment---------------->
                          <div class="mode-payment p-1">
                            <div
                              class="
                                list-group-item
                                d-flex
                                justify-content-center
                              "
                            >
                              <div
                                class="
                                  payment-type
                                  clickable
                                  d-flex
                                  justify-content-center
                                  align-items-center
                                  mx-1
                                "
                                v-for="(mode, index) in availablePaymentMode"
                                :key="index"
                                @click="OnPayementTypeChanged(mode.type)"
                              >
                                <div
                                  v-if="cart.payment_type == mode.type"
                                  class="
                                    d-flex
                                    flex-column
                                    justify-content-center
                                    align-items-center
                                  "
                                >
                                  <span class="p-0 m-0 w-100 text-center">{{ mode.label }}</span>
                                  <i
                                    class="
                                      k-icon-ok-circled
                                      text-success
                                      active
                                    "
                                  ></i>
                                </div>
                                <div v-else class="availale-mode">
                                  <div class="icon">
                                    <el-image :src="mode.icon" />
                                  </div>
                                  <div class="text">
                                    {{ mode.label }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="required"
                              v-if="errors.payment_type === true"
                            >
                              {{ $t("text.please_select_payment_mode") }}
                            </div>
                          </div>

                          <div
                            class="py-4"
                            v-if="
                              cart.payment_type >= enumHelper.paymentType.Card
                            "
                          >
                            <div class="row">
                              <div class="col-md-12 col-md-12 text-center">
                                <img
                                  src="img/stripenomobilepay.svg"
                                  class="stripeImg"
                                  alt="Image"
                                />
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12 col-md-12 text-center">
                                <div
                                  v-if="
                                    cart.payment_type ==
                                    enumHelper.paymentType.ApplePay
                                  "
                                >
                                  <img
                                    src="img/apple-payment-mode.svg"
                                    class="apple-pay-img"
                                    alt="Image"
                                  />
                                </div>
                                <div
                                  v-else-if="
                                    cart.payment_type ==
                                    enumHelper.paymentType.GooglePay
                                  "
                                >
                                  <img
                                    src="img/google-payment-mode.svg"
                                    class="google-pay-img"
                                    alt="Image"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="stripe-wrapper"
                            v-show="
                              cart.payment_type == enumHelper.paymentType.Card
                            "
                          >
                            <!---------------Start Card Selection ---------------->
                            <div
                              class="form-group input-group"
                              v-if="isAuthenticated"
                            >
                              <el-select
                                v-if="userCards && userCards.length"
                                @change="OnCardSelection"
                                v-model="card_id"
                                :placeholder="
                                  selectedCard
                                    ? ''
                                    : $t('input.placeholder.select_card')
                                "
                                :class="{
                                  'has-danger': errors.card_id,
                                  'has-success': errors.card_id === false,
                                }"
                              >
                                <el-option
                                  class="clear-selection"
                                  v-if="card_id > 0"
                                  label="Clear Selection"
                                  value="-1"
                                ></el-option>
                                <el-option
                                  :disabled="
                                    disableExpiredCard(item.stripe_object)
                                  "
                                  v-for="(item, index) in userCards"
                                  :key="index"
                                  :value="item.id"
                                >
                                  <div
                                    class="card-option media float-left"
                                    v-if="item.stripe_object"
                                  >
                                    <div class="card-icon mr-2">
                                      <el-image
                                        :src="
                                          helpers.getCardBrandIcon(
                                            item.stripe_object
                                          )
                                        "
                                      />
                                    </div>
                                    <div class="media-body card-text">
                                      {{
                                        helpers.getCardNumberWithStars(
                                          item.stripe_object.last4
                                        )
                                      }}
                                    </div>
                                  </div>
                                  <div
                                    class="card-text float-right"
                                    style="color: #8492a6"
                                    v-if="item.stripe_object"
                                  >
                                    <span v-if="card_id != item.id"
                                      >{{ textExpiredCard(item.stripe_object) }}
                                    </span>
                                    <i
                                      v-else
                                      class="
                                        k-icon-ok-circled
                                        active-selected-card
                                      "
                                    ></i>
                                  </div>
                                </el-option>
                                <template v-if="selectedCard" #prefix>
                                  <div
                                    class="card-option media float-left w-100"
                                  >
                                    <div class="card-icon mr-2">
                                      <el-image
                                        :src="
                                          helpers.getCardBrandIcon(
                                            selectedCard.stripe_object
                                          )
                                        "
                                      />
                                    </div>
                                    <div class="media-body card-text">
                                      {{
                                        helpers.getCardNumberWithStars(
                                          selectedCard.stripe_object.last4
                                        )
                                      }}
                                    </div>
                                    <div class="card-text float-right">
                                      <i
                                        class="
                                          k-icon-ok-circled
                                          active-selected-card
                                        "
                                      ></i>
                                    </div>
                                  </div>
                                </template>
                              </el-select>
                            </div>
                            <!---------------End Card Selection ---------------->
                            <!---------------Start Stripe Card ---------------->
                            <div
                              class="form-group input-group"
                              v-if="
                                stripeIsMounted &&
                                card_id == null &&
                                cart.payment_type == enumHelper.paymentType.Card
                              "
                            >
                              <card
                                ref="newCard"
                                class="form-control stripe-card"
                                :class="{ complete }"
                                :stripe="stripeKey"
                                :options="stripeOptions"
                                :stripe-options="{
                                  apiVersion: helpers.getStripeApiVersion(),
                                }"
                                @change="OnCardChange"
                              />
                            </div>
                            <!------------ Will be displayed , if the user don't select a card  in first Step : depend if is user or guest--------------------->
                            <div
                              class="required form-group input-group"
                              v-if="errors.payment_mode === true"
                            >
                              {{
                                isAuthenticated
                                  ? $t("text.select_pre_saved_card")
                                  : $t("text.please_provide_card_to_continue")
                              }}
                            </div>
                            <!---------------End Stripe Card ---------------->
                            <!---------------End payment---------------->
                            <!-------------- Propose to the guest to connect ------------------>
                            <div
                              class="form-group input-group"
                              v-if="!isAuthenticated"
                            >
                              <n-button
                                type="primary"
                                @click="redirectToLogin"
                                :style="myTheme.customizeButton"
                                >{{ $t("text.login_to_save_card") }}</n-button
                              >
                            </div>
                            <!--------------- Propose to Save the new Introduced card --------------->
                            <div
                              v-else-if="
                                card_id == null &&
                                cart.payment_type == enumHelper.paymentType.Card
                              "
                              class="form-group input-group"
                            >
                              <n-checkbox
                                v-model="cart.save_card"
                                style="width: 100%"
                                :disabled="disableSaveCard"
                                >{{
                                  $t("text.save_card_for_next_use")
                                }}</n-checkbox
                              >
                            </div>
                            <!--------------- Propose to Save the new Introduced card --------------->
                          </div>
                          <!---------------End payment---------------->
                        </template>
                      </cards>
                    </div>
                  </div>
                </div>
              </tab-pane>
              <tab-pane
                :disabled="
                  orderCompleted &&
                  orderCompleted.step <= enumHelper.steps.STEP03
                "
                label="Step03"
              >
                <template slot="label">
                  <i class="now-ui-icons shopping_shop"></i>
                  {{ $t("text.step_03") }}
                </template>
                <div class="section-steps-3" v-if="orderCompleted">
                  <div class="container">
                    <div class="row">
                      <sweetalert-icon :icon="notificationType" />
                      <cards class="menu-card mb-3">
                        <div class="list-group-item">
                          {{
                            $t("text.step_3_desc", {
                              orderId: orderCompleted.id,
                            })
                          }}
                        </div>
                      </cards>
                      <n-button
                        :disabled="loadTracking"
                        :style="myTheme.registrationButtons"
                        type="primary"
                        v-if="orderCompleted"
                        @click="displayOrderTrack"
                        round
                        block
                        class="mb-4"
                      >
                        <i
                          v-if="loadTracking"
                          class="k-icon-spin4 animate-spin"
                        ></i>
                        {{ $t("button.track_order_progress") }}</n-button
                      >
                      <cards class="menu-card">
                        <div class="list-group-item">
                          <ul class="list-group list-group-flush">
                            <li
                              class="list-group-item"
                              v-if="orderCompleted && orderCompleted.user"
                            >
                              <strong>{{ $t("text.customer_name") }}:</strong>
                              {{
                                orderCompleted.user.first_name +
                                " " +
                                orderCompleted.user.last_name
                              }}
                            </li>
                            <li class="list-group-item">
                              <strong>{{ $t("text.contact_number") }} :</strong>
                              {{ orderCompleted.user.telephone_number }}
                            </li>
                            <li class="list-group-item">
                              <strong>{{ $t("text.order_type") }} :</strong>
                              {{
                                helpers.getOrderTypeText(
                                  orderCompleted.orderType
                                )
                              }}
                            </li>
                            <li
                              class="list-group-item"
                              v-if="
                                orderCompleted.orderType ===
                                enumHelper.orderType.Delivery
                              "
                            >
                              <strong
                                >{{ $t("text.delivery_address") }} :</strong
                              >
                              {{
                                helpers.generateFromatedAddress(
                                  orderCompleted.address
                                )
                              }}
                            </li>
                            <li class="list-group-item">
                              <strong>{{ $t("text.time") }} :</strong>
                              {{ getDateTimeText(orderCompleted.pickUp) }}
                            </li>
                            <li class="list-group-item">
                              <strong>{{ $t("text.payment_method") }}:</strong>
                              {{
                                orderCompleted.payment_type ==
                                enumHelper.paymentType.Cash
                                  ? $t("text.cash_payment")
                                  : $t("text.card_payment")
                              }}
                            </li>
                          </ul>
                        </div>
                      </cards>
                      <p>{{ $t("text.your_order") }} :</p>
                      <cards
                        class="menu-card"
                        v-for="(item, index) in orderCompleted.order"
                        :key="index"
                      >
                        <div class="wrapper-menu-Item">
                          <div class="box favorite">
                            <i
                              class="new-ui-icons"
                              :class="{
                                'k-icon-tab-favourites fav': item.is_favourite,
                                'k-icon-heart-line': !item.is_favourite,
                              }"
                            ></i>
                          </div>
                          <div class="box details">
                            <p
                              class="title"
                              :style="{ color: myTheme.primaryTextColor }"
                            >
                              {{ item.name }}
                            </p>

                            <div class="options-item">
                              <div v-if="item.options && item.options.length">
                                <div
                                  v-for="(option, index) in item.options"
                                  :key="index"
                                >
                                  <div
                                    v-if="
                                      option.type === 'RADIO' ||
                                      option.type === 'SELECT'
                                    "
                                  >
                                    <div
                                      class="options-item-grid"
                                      v-for="(value, index) in option.values"
                                      :key="index"
                                    >
                                      <div
                                        v-if="value.id == option.selected"
                                        class="option-name"
                                      >
                                        ++ {{ value.name }}
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="option.type === 'CHECKBOX'">
                                    <div
                                      class="options-item-grid"
                                      v-for="(
                                        idValue, index
                                      ) in option.selected"
                                      :key="index"
                                    >
                                      <div v-if="idValue" class="option-name">
                                        ++
                                        {{
                                          helpers.getValueName(
                                            option.values,
                                            idValue
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="options-comment" v-if="item.comment">
                              [{{ item.comment }}]
                            </div>
                            <div
                              class="d-inline dietry-requirements"
                              v-for="(
                                dieatry, index
                              ) in helpers.getMenuItemDieatriesIcons(item)"
                              :key="index"
                            >
                              <i
                                class="new-ui-icons mr-1"
                                :class="dieatry.icon"
                                :title="dieatry.name"
                              ></i>
                            </div>
                          </div>
                          <div class="box price text-center my-auto">
                            {{
                              helpers.getItemTotal(
                                item,
                                orderCompleted.orderType
                              ) | currency(currentCurrency)
                            }}
                          </div>
                          <div class="box counter text-center my-auto">
                            <span>{{ item.quantity }}x</span>
                          </div>
                        </div>
                      </cards>
                      <div class="grid-payment">
                        <div class="grid-label">
                          {{ $t("text.sub_total") }} :
                        </div>
                        <div class="grid-value">
                          {{ orderCompleted.total | currency(currentCurrency) }}
                        </div>
                        <div class="grid-label">
                          {{ $t("text.service_charges") }} :
                        </div>
                        <div class="grid-value">
                          {{
                            orderCompleted.service_charge
                              | currency(currentCurrency)
                          }}
                        </div>
                        <div class="grid-label" v-if='orderCompleted.bag_charge && orderCompleted.bag_charge != "0.00"' >
                          {{ $t("text.bag_charge") }} :
                        </div>
                        <div class="grid-value" v-if='orderCompleted.bag_charge && orderCompleted.bag_charge != "0.00"'>
                          {{
                            orderCompleted.bag_charge
                              | currency(currentCurrency)
                          }}
                        </div>
                        <div
                          class="grid-label red"
                          v-if="
                            orderCompleted.orderType ==
                            enumHelper.orderType.Delivery
                          "
                        >
                          {{ $t("text.delivery_fee") }} :
                        </div>
                        <div
                          class="grid-value red"
                          v-if="
                            orderCompleted.orderType ==
                            enumHelper.orderType.Delivery
                          "
                        >
                          {{
                            orderCompleted.delivery_fee
                              | currency(currentCurrency)
                          }}
                        </div>
                        <div
                          class="grid-label green"
                          v-if="orderCompleted.coupon_result"
                        >
                          {{ $t("text.discount") }} :
                        </div>
                        <div
                          class="grid-value green"
                          v-if="orderCompleted.coupon_result"
                        >
                          {{
                            orderCompleted.coupon_result.discountAmount
                              | currency(currentCurrency)
                          }}
                        </div>
                        <div class="grid-label order-total">
                          {{ $t("text.order_total") }} :
                        </div>
                        <div class="grid-value order-total">
                          {{
                            orderCompleted.orderTotal
                              | currency(currentCurrency)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </tab-pane>
            </tabs>
          </cards>
          <!--------------- Start Generate payment Buttons ---------------->
          <div class="send-button">
            <b-alert v-model="showEmailAlert" variant="danger" dismissible>{{
              this.emailExist
            }}</b-alert>
            <div
              v-if="displayNativeApplePayButton"
              @click="startNativePay"
              class="
                apple-pay-button-with-text apple-pay-button-black-with-text
              "
            >
              <span class="text">Buy with</span>
              <span class="logo"></span>
            </div>
            <div
              v-else-if="displayApplePayButton"
              @click="paymentRequestResult.show()"
              class="
                apple-pay-button-with-text apple-pay-button-black-with-text
              "
            >
              <span class="text">Buy with</span>
              <span class="logo"></span>
            </div>
            <!--div
              v-else-if="displayNativeGooglePayButton"
              class="button-google-pay"
              @click="startNativePay"
            ></!--div-->
            <div
              v-else-if="displayGooglePayButton"
              class="button-google-pay"
              @click="paymentRequestResult.show()"
            ></div>
            <n-button
              :style="myTheme.customizeButton"
              type="primary"
              v-else-if="displayPayButton"
              :disabled="
                processing ||
                disable ||
                !cart ||
                !cart.order ||
                !cart.order.length
              "
              @click="onClick"
              round
              block
              >{{ buttonTitle }}</n-button
            >
          </div>
          <!---------------Start Generate payment Buttons ---------------->
          <div class="back-to-menu-link mt-3">
            <a
              href="#"
              @click="goToMenu"
              class="url-color"
              v-if="orderCompleted.step <= enumHelper.steps.STEP02"
            >
              <p>{{ $t("button.back_to_menu") }}</p>
            </a>
            <router-link to="/" class="url-color" v-else>
              <p>{{ $t("button.back_to_home") }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <modal
      :ignoreBackdropClick="true"
      @close="modalClosed"
      :show.sync="show"
      headerClasses="justify-content-center"
      class="modal-options"
      modalClasses="modal-dialog-centered modal-dialog-scrollable"
    >
      <h4 slot="header" class="title title-up">
        {{
          isNewAddress ? $t("text.add_new_address") : $t("text.edit_address")
        }}
      </h4>
      <add-address
        :fromModal="true"
        :isNewAddress="isNewAddress"
        @exit="onCloseModal"
        :address="addressToEditData"
      ></add-address>
    </modal>
    <order-view-status-modal
      ref="itemStatusModal"
      :order="objOrderHistory"
    ></order-view-status-modal>
  </section>
</template>

<script>
import { helpers, cartManager, enumHelper } from "@/utilities";
import { mapState, mapActions, mapGetters } from "vuex";
import router from "@/router";
import couponMixin from "../mixins/couponMixin";
import {
  Cards,
  Tabs,
  TabPane,
  Button,
  FormGroupInput,
  FormTexterea,
  Checkbox,
  RadioButton,
  Radio,
  Modal,
} from "@/components";
import {
  AddressLookupForm,
  AddAddress,
  OrderViewStatusModal,
} from "@/views/components";
import Vue2Filters from "vue2-filters";
import objectAddress from "@/model/address";
import { Card } from "vue-stripe-elements-plus-sa";
import onMesssageMixin from "@/mixins/onMesssageMixin";
import paymentMixin from "@/mixins/paymentMixin";

export default {
  name: "checkout",
  mixins: [Vue2Filters.mixin, onMesssageMixin, paymentMixin, couponMixin],
  components: {
    [Radio.name]: Radio,
    Cards,
    Tabs,
    TabPane,
    [Button.name]: Button,
    [RadioButton.name]: RadioButton,
    [FormGroupInput.name]: FormGroupInput,
    [FormTexterea.name]: FormTexterea,
    [Checkbox.name]: Checkbox,
    Modal,
    AddAddress,
    AddressLookupForm,
    Card,
    OrderViewStatusModal,
  },
  computed: {
    couponStatus() {
      if (!this.cart) return null;
      if (this.cart.coupon_result) {
        return {
          title: this.$t("message.discount_msg_status", {
            discount: this.$options.filters.currency(
              this.cart.coupon_result.discountAmount
            ),
          }),
          type: "success",
        };
      }
      return null;
      /*else if (this.cart.coupon_error) {
        return {
          title:
            this.cart.coupon_error.error && this.cart.coupon_error.error.message
              ? this.cart.coupon_error.error.message
              : "the coupon code " + this.cart.coupon + " is no longer valid",
          type: "error",
        };
      }
      return {
        title: "",
        type: "",
      };*/
    },
    ...mapGetters(["isAuthenticated", "guestData"]),
    ...mapState({
      user: (state) => state.auth.user,
      orderTotal: (state) => state.orderTotal,
      userCards: (state) => state.userCards,
    }),
    buttonTitle() {
      if (this.cart.step == enumHelper.steps.STEP02) {
        if (this.cart.payment_type == enumHelper.paymentType.Cash)
          return this.$t("button.place_order_for", {
            total_price: this.$options.filters.currency(this.orderTotal),
          });
        return this.$t("button.pay", {
          total_price: this.$options.filters.currency(this.orderTotal),
        });
      }
      return this.$t("button.payment");
    },
    locationStatus: function () {
      return helpers.canMakeOrder(this.selectedLocation);
    },
    notificationType() {
      if (this.orderCompleted.status == enumHelper.status.COMPLETED)
        return "success";
      else return "error";
    },
    orderCompleted() {
      return JSON.parse(localStorage.getItem("saved-order")) || this.cart;
    },
    displayNativeApplePayButton() {
      return (
        this.cart.step == enumHelper.steps.STEP02 &&
        this.cart.payment_type == enumHelper.paymentType.ApplePay &&
        this.getNativeApplePayStatus
      );
    },
    displayNativeGooglePayButton() {
      return false;
      //-- TODO : Enable when Native Google Pay is working
      /*return (
        this.cart.step == enumHelper.steps.STEP02 &&
        this.cart.payment_type == enumHelper.paymentType.GooglePay &&
        this.getNativeGooglePayStatus
      );*/
    },
    displayApplePayButton() {
      return (
        this.cart.step == enumHelper.steps.STEP02 &&
        this.canMakePayment &&
        this.canMakePayment.applePay &&
        this.cart.payment_type == enumHelper.paymentType.ApplePay
      );
    },
    displayGooglePayButton() {
      return (
        this.cart.step == enumHelper.steps.STEP02 &&
        this.canMakePayment &&
        this.canMakePayment.googlePay &&
        this.cart.payment_type == enumHelper.paymentType.GooglePay
      );
    },
    displayPayButton() {
      return (
        this.orderCompleted.step == enumHelper.steps.STEP01 ||
        this.orderCompleted.step == enumHelper.steps.STEP02
      );
    },
    displayASAPButton() {
      return ( this.selectedLocation && (
        (this.cart.orderType == enumHelper.orderType.Delivery &&
          this.selectedLocation.openingHours.delivery) ||
        (this.cart.orderType == enumHelper.orderType.Collection &&
          this.selectedLocation.openingHours.collection) ||
        (this.cart.orderType == enumHelper.orderType.Table &&
          this.selectedLocation.openingHours.sitIn)
      ));
    },
    disableExpiredCard() {
      return (cardDetails) => {
        return this.isCardExpired(cardDetails);
      };
    },
    textExpiredCard() {
      return (cardDetails) => {
        return this.isCardExpired(cardDetails)
          ? `${this.$t("text.expired_on", {
              month_year: `${helpers.pad2(cardDetails.exp_month)}/${
                cardDetails.exp_year
              }`,
            })}`
          : `${this.$t("text.expires_on", {
              month_year: `${helpers.pad2(cardDetails.exp_month)}/${
                cardDetails.exp_year
              }`,
            })}`;
      };
    },
    selectedCard() {
      return this.card_id > 0
        ? this.userCards.find((x) => x.id == this.card_id)
        : null;
    },
  },
  data() {
    return {
      showEmailAlert: false,
      isNewAddress: true,
      disableSaveCard: true, // disable/enable save card checbox
      cart: cartManager.InitCart(),
      enumHelper,
      helpers,
      errors: {
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        date: null,
        time: null,
        payment_type: null,
        agree: null,
        payment_mode: null,
      },
      emailExist: null,
      datePickerOptions: {
        disabledDate: this.disabledDatePickerDates,
      },
      timeOptions: [],
      addressToEditData: Object.assign({}, objectAddress),
      address_id: null,
      card_id: null,
      table_id: null,
      complete: false,
      isAgree: false,
      disable: false,
      success: false,
      show: false, // used to show the add new address modal
      laterDateTimeSettings: null,
      currentUser: null,
      isMounted: false,
      deliverFeeStatus: null,
      objOrderHistory: null,
      processing: false,
      loadTracking: false,
    };
  },
  methods: {
    ...mapActions([
      "fetchLocation",
    ]),

    //*************************** Start Methods for the inputs ****************************** */
    //--- save / confirm the payment process
    onClick() {
      this.processing = true;
      if (this.checkUserForm()) {
        this.processing = false;
      } else {
        this.refreshLocationData()
          .then(() => {
            if (
              !helpers.validLastOrderDateTime(
                this.selectedLocation,
                this.cart.orderType,
                this.cart.pickUp
              )
            ) {
              let message = this.$t("message.location_stop_taken_orders", {
                location_name: this.selectedLocation.name,
              });
              if (this.selectedLocation.openingHours.suspended) {
                message = this.$t("message.location_temporary_paused_to", {
                  paused_to: this.selectedLocation.paused_to,
                });
              }

              helpers
                .showErrorMessageAlert(
                  message,
                  null,
                  "red",
                  this.$t("button.ok")
                )
                .then(() => {
                  this.processing = false;
                  this.goToHome();
                });
            } else if (
              helpers.controlAvailibilityBeforeCheckout(
                this.locationStatus,
                cartManager.getCart()
              )
            ) {
              let message = this.$t("message.location_temporary_closed");
              if (this.selectedLocation.openingHours.suspended) {
                message = this.$t("message.location_temporary_paused_to", {
                  paused_to: this.selectedLocation.paused_to,
                });
              }

              helpers
                .showErrorMessageAlert(
                  message,
                  null,
                  "red",
                  this.$t("button.ok")
                )
                .then(() => {
                  this.processing = false;
                  this.goToHome();
                });
            } else {
              this.emailExist = null;
              this.errors.email = null;
              /* this.fetchCategories(this.selectedLocation.id)
              .then((menu) => {*/
              helpers
                .checkOrderItemsAvailibility(
                  this.cart.order,
                  helpers.generateOrderDateTime(this.cart.pickUp),
                  this.locationMenuItems
                )
                .then((itemsNotAvailableFor) => {
                  if (
                    itemsNotAvailableFor.today.length ||
                    itemsNotAvailableFor.now.length
                  ) {
                    let message = "";
                    if (itemsNotAvailableFor.today.length) {
                      message = `${this.$t(
                        "message.items_not_available_for_today"
                      )} : <br> <ul class='order-items'>`;
                      itemsNotAvailableFor.today.forEach((item) => {
                        message += `<li>${item.name}</li>`;
                      });
                      message += "</ul>";
                    }
                    if (itemsNotAvailableFor.now.length) {
                      message += `${this.$t(
                        "message.items_not_available_for_now"
                      )} : <br> <ul class='order-items'>`;
                      itemsNotAvailableFor.now.forEach((item) => {
                        message += `<li>${item.name}</li>`;
                      });
                      message += "</ul>";
                    }

                    message += message += `<p class='message'>${this.$t(
                      "message.select_another_interval"
                    )}</p>`;
                    this.processing = false;
                    helpers
                      .showMessageConfirmation(
                        message,
                        "k-icon-preptime",
                        this.staticColor.orange,
                        this.$t("button.continue"),
                        this.$t("button.go_to_menu")
                      )
                      .then((confirm) => {
                        if (!confirm) {
                          //--- remove the outdated items
                          let itemsId = itemsNotAvailableFor.today
                            .concat(itemsNotAvailableFor.now)
                            .map((x) => x.id);
                          this.$root.$emit("REMOVE_ITEMS", itemsId);
                          this.$nextTick(() => {
                            this.goToMenu();
                          });
                        }
                      });
                  } else {
                    //--- verify the coupon if any is provided | coupon is only availabled for logged users
                    if (this.user && this.cart.coupon) {
                      this.onSubmitCoupon(false, false).then((result) => {
                        if (result.valid && !result.auto) {
                          //--- the original coupon is valide and the payment process can continue
                          this.continuePaymentProcess();
                        } else {
                          let message = this.$t(
                            "message.sorry_coupon_no_longer_valid"
                          );

                          if (result.valid && result.auto) {
                            message += this.$t("message.autocoupon_applied", {
                              orderTotal: this.cart.orderTotal,
                            });
                          }
                          message += this.$t(
                            "message.click_to_process_payment"
                          );

                          this.processing = false;
                          helpers
                            .showMessageConfirmation(
                              message,
                              "k-icon-preptime",
                              this.staticColor.orange,
                              this.$t("button.continue"),
                              this.$t("button.go_to_menu")
                            )
                            .then((confirm) => {
                              if (confirm) {
                                this.processing = false;
                                this.continuePaymentProcess();
                              } else {
                                this.goToMenu();
                              }
                            });
                        }
                      });
                    } else {
                      this.continuePaymentProcess();
                    }
                  }
                });
            }
          })
          .catch((e) => {
            this.captureException(e);
            this.orderFailed(this.$t("generic_error.refresh_location_data"));
          });
      }
    },
    continuePaymentProcess() {
      switch (this.cart.step) {
        case enumHelper.steps.STEP01: {
          if (
            this.cart.status == enumHelper.status.PREPARED ||
            this.cart.status == enumHelper.status.SAVED
          ) {
            cartManager
              .generateOrderObject(this.cart, this.selectedLocation.id)
              .then((response) => {
                if (this.isAuthenticated) this.postOrder(response);
                else this.PostGuestOrder(response);
              })
              .catch((e) => {
                this.captureException(e);
                this.processing = false;
                this.orderFailed(
                  this.$t("generic_error.error_generating_order"),
                  this.$t("button.back_to_checkout")
                );
              });
          }
          break;
        }
        case enumHelper.steps.STEP02: {
          //***** Start the payment */
          if (this.cart.status == enumHelper.status.SAVED) {
            this.tokenize()
              .then(() => {
                cartManager
                  .generatePaymentObject(this.cart, this.selectedLocation.id)
                  .then((response) => {
                    if (this.isAuthenticated) this.postPayment(response);
                    else this.PostGuestPayment(response);
                  })
                  .catch((e) => {
                    this.captureException(e);
                    this.orderFailed(
                      this.$t("generic_error.error_generating_payment"),
                      this.$t("button.back_to_checkout")
                    );
                  });
              })
              .catch((e) => {
                this.captureException(e);
                this.orderFailed(
                  helpers.geMessageByStripeErrorCode(e),
                  this.$t("button.back_to_checkout")
                );
              });
          }
        }
      }
    },
    //---- Fired on payment type changed :
    OnPayementTypeChanged(value) {
      this.cart.payment_type = value;
      if (value != enumHelper.paymentType.Card) {
        this.card_id = null;
        this.cart.card = null;
        this.cart.card_id = null;
      }
      cartManager.setCart(this.cart, false, false);
    },

    //--- to check the stripe card element
    OnCardChange(event) {
      this.complete = event.complete;
      this.disableSaveCard = !this.complete;
      if (this.complete) {
        this.card_id = null;
        this.cart.card_id = null;
        cartManager.setCart(this.cart, false, false);
      }
    },
    //---- Fired when the user select a Card from pre-saved cards
    OnCardSelection: function () {
      if (this.card_id > 0) {
        let obj = this.userCards.find((x) => x.id == this.card_id);
        this.cart.card = obj;
        this.cart.card_id = this.card_id;
        this.clearCard();
        this.cart.save_card = false;
        cartManager.setCart(this.cart, false, false);
      } else {
        // Card cleared
        this.card_id = null;
        this.cart.card_id = null;
      }
    },

    //---- Fired When Table is selected => To save the select table number/name
    OnTableChanged: function () {
      if (this.table_id) {
        let _table = this.selectedLocation.tables.find(
          (x) => x.id === this.table_id
        );
        this.cart.table = {
          id: _table.id,
          name: _table.name,
        };
      }
    },
    //---- Fired When address is selected and check the delivery availability.
    OnAddressChanged: function () {
      if (this.address_id) {
        let addressFound = this.user.addresses.find(
          (x) => x.id === this.address_id
        );
        //**** if the address is missing street number => display the address modal to update the address */
        if (!addressFound.street_number) {
          this.addressToEditData = addressFound;
          this.isNewAddress = false;
          this.show = true;
        } else {
          this.cart.address = addressFound;
          if (this.cart.address) this.checkTheDeliveryAddess(); //---- check
        }
      }
    },
    onAddNewAddress() {
      this.addressToEditData = Object.assign({}, objectAddress);
      this.isNewAddress = true;
      this.show = true;
    },
    //---- check the guest Address
    setCartAddress(addressData) {
      this.cart.address = addressData;
      //console.log(this.cart.address);
      //--- check the delivery to this Address :
      if (this.cart.address) this.checkTheDeliveryAddess(); //---- check
    },
    OnTimeChanged() {
      if (this.cart.pickUp.type == enumHelper.PickupTime.LATER) {
        this.cart.pickUp.date = this.cart.pickUp.date || new Date();
        this.setTimeOption(this.cart.pickUp.date);
      } else {
        this.cart.pickUp.date = null;
        this.cart.pickUp.time = null;
      }
    },
    //---- post the order to the server
    postOrder(data) {
      this.postOrderRequest(data)
        .then((response) => {
          if (response && response.error) {
            this.orderFailed(
              helpers.getMessageFromAPIError(response),
              this.$t("button.back_to_checkout")
            );
            return;
          }
          //----- save the api response
          this.cart.status = enumHelper.status.SAVED;
          this.cart.newOrder = response.order;
          this.cart.id = response.order.id;
          this.cart.step = enumHelper.steps.STEP02;
          cartManager.setCart(this.cart, false, false);
          this.processing = false;
        })
        .catch((e) => {
          this.captureException(e);
          this.cart.status = enumHelper.status.PREPARED;
          this.cart.step = enumHelper.steps.STEP01;
          this.cart.id = null;
          this.cart.newOrder = null;
          cartManager.setCart(this.cart, false, false);
          if (e && e.data) {
            this.orderFailed(
              helpers.getMessageFromAPIError(e.data),
              this.$t("button.back_to_checkout")
            );
          } else {
            this.orderFailed(
              "An error occured when saving your order, please try again",
              this.$t("button.back_to_checkout")
            );
          }
        });
    },
    PostGuestOrder(data) {
      this.postGuestOrderRequest(data)
        .then((response) => {
          if (
            response &&
            response.error &&
            (response.error.message === "User exists!" ||
              "User already exists!")
          ) {
            this.emailExist = this.$t("message.email_exist");
            this.errors.email = true;
            this.processing = false;
            return;
          }
          if (response && response.error) {
            this.orderFailed(
              helpers.getMessageFromAPIError(response),
              this.$t("button.back_to_checkout")
            );
            return;
          }
          //----- save the api response
          this.cart.status = enumHelper.status.SAVED;
          this.cart.newOrder = response.order;
          this.cart.id = response.order.id;
          this.cart.step = enumHelper.steps.STEP02;
          cartManager.setCart(this.cart, false, false);
          this.processing = false;
        })
        .catch((e) => {
          this.captureException(e);
          this.cart.status = enumHelper.status.PREPARED;
          this.cart.step = enumHelper.steps.STEP01;
          this.cart.id = null;
          this.cart.newOrder = null;
          cartManager.setCart(this.cart, false, false);
          if (e && e.data) {
            this.orderFailed(
              helpers.getMessageFromAPIError(e.data),
              this.$t("button.back_to_checkout")
            );
          } else {
            this.orderFailed(
              this.$t("generic_error.error_saving_order"),
              this.$t("button.back_to_checkout")
            );
          }
        });
    },

    //---- fired when selecting a date
    onDateChanged: function (value) {
      this.cart.pickUp.time = null;
      this.setTimeOption(value);
    },
    //--- selectet automaticaly the new added address and close the modal
    onCloseModal(result) {
      this.show = result.show;
      this.isNewAddress = false;
      if (result.address) {
        this.address_id = result.address.id;
        this.cart.address = result.address;

        this.checkTheDeliveryAddess(); //---- check
      }
    },
    modalClosed() {
      if (!this.cart.address.street_number) {
        this.address_id = null;
        this.cart.address = objectAddress;
      }
    },
    //*************************** End Methods for the inputs ****************************** */

    //*************************** Start components Methods ****************************** */
    checkUserForm() {
      if (this.cart.step == enumHelper.steps.STEP01) {
        this.errors.firstName = !this.cart.user.first_name; //!
        this.errors.lastName = !this.cart.user.last_name;
        this.errors.email = !this.cart.user.email;
        this.errors.phoneNumber = !this.cart.user.telephone_number;

        if (this.cart.pickUp.type == enumHelper.PickupTime.LATER) {
          this.errors.date = !this.cart.pickUp.date;
          this.errors.time = !this.cart.pickUp.time;
        } else {
          this.errors.date = null;
          this.errors.time = null;
        }
        if (this.cart.orderType == enumHelper.orderType.Delivery) {
          if (this.cart.address.id)
            this.errors.address =
              !helpers.evaluateValue(this.cart.address.postcode) ||
              !helpers.evaluateValue(this.cart.address.street_number) ||
              !helpers.evaluateValue(this.cart.address.city) ||
              !helpers.evaluateValue(this.cart.address.region) ||
              !helpers.evaluateValue(this.cart.address.address_line_1);
          else
            this.errors.address =
              !helpers.evaluateValue(this.addressToEditData.postcode) ||
              !helpers.evaluateValue(this.addressToEditData.street_number) ||
              !helpers.evaluateValue(this.addressToEditData.city) ||
              !helpers.evaluateValue(this.addressToEditData.region) ||
              !helpers.evaluateValue(this.addressToEditData.address_line_1);
        }

        this.errors.table =
          this.cart.orderType == enumHelper.orderType.Table
            ? !helpers.evaluateValue(this.table_id)
            : null;

        this.errors.agree = !this.isAgree;
      } else if (this.cart.step == enumHelper.steps.STEP02) {
        this.errors.payment_type = !this.cart.payment_type;
        if (this.cart.payment_type == enumHelper.paymentType.Card) {
          this.errors.payment_mode =
            !helpers.evaluateValue(
              this.cart.user && this.cart.user.id && this.card_id
            ) && !this.complete;
        } else {
          this.errors.payment_mode = null;
        }
      }

      return Object.keys(this.errors).some((k) => this.errors[k]); // check if any of the element generate an error
    },
    //---- check if the location provide he service delivery to the provided address
    checkTheDeliveryAddess() {
      this.disable = true;
      //---- get the location with the address postcode
      this.fetchLocation({
        id: this.selectedLocation.id,
        postcode: this.cart.address.postcode,
      })
        .then(() => {
          this.deliverFeeStatus = helpers.checkDeliveryAvailibality(
            this.locationStatus.can_make_order,
            this.selectedLocation,
            this.cart.orderTotal,
            true
          );
          if (this.deliverFeeStatus) {
            if (this.deliverFeeStatus.status) {
              this.cart.delivery_fee = this.deliverFeeStatus.value;
              cartManager.setCart(this.cart, true, false);
            }
            this.disable = !this.deliverFeeStatus.status;
          } else {
            //**** TODO : display a popup message */
            helpers
              .showErrorMessageAlert(
                this.$t("message.location_temporary_closed"),
                null,
                "red",
                this.$t("button.ok")
              )
              .then(() => {
                this.goToHome();
              });
          }
        })
        .catch((e) => {
          this.captureException(e);
          this.deliverFeeStatus = {
            status: false,
            type: "error",
            title: this.$t("validation.valid_address"),
          };
        });
    },
    setTimeOption(date) {
      this.timeOptions = [];
      let currentTime = this.$moment(Date.now());

      let local_date = new Date(date);
      //console.log(local_date);
      //console.log(`${local_date.getDate()}/${local_date.getMonth() + 1}/${local_date.getFullYear()}`);
      let selectedDate_moment = this.$moment(
        `${local_date.getDate()}/${
          local_date.getMonth() + 1
        }/${local_date.getFullYear()}`,
        "DD/MM/YYYY"
      );
      //console.log(selectedDate_moment);
      let selectedDate = selectedDate_moment.format("YYYY-MM-DD");
      //console.log(selectedDate);
      //console.log(this.laterDateTimeSettings.orderingDates)
      let periods = this.laterDateTimeSettings.orderingDates[selectedDate];

      if (!periods) return [];
      //console.log(periods);

      periods.forEach((item) => {
        //--- create moment date_time fro data manipulation and comparaison
        let dt_OpenAt = this.$moment(
          selectedDate + " " + item.opens_at,
          "YYYY-MM-DD HH:mm"
        );
        let dt_ClosesAt = this.$moment(
          selectedDate + " " + item.closes_at,
          "YYYY-MM-DD HH:mm"
        );

        let periodStart = dt_OpenAt.isSameOrAfter(currentTime)
          ? dt_OpenAt
              .clone()
              .add(this.laterDateTimeSettings.deliveryPickupTime, "minutes")
              .format("HH:mm")
          : currentTime
              .add(this.laterDateTimeSettings.deliveryPickupTime, "minutes")
              .format("HH:mm");

        periodStart = helpers.roundTimeQuarterHour(periodStart);

        let periodEnd = dt_ClosesAt.format("HH:mm");

        this.timeOptions = [
          ...this.timeOptions,
          ...helpers.getQuarterOrderTimesFromPeriod(
            selectedDate,
            periodStart,
            periodEnd
          ),
        ];
      });
    },
    getOrderSettingsByType() {
      switch (this.cart.orderType) {
        case enumHelper.orderType.Delivery:
          //_ordering_Dates = this.selectedLocation.delivery_time;
          return {
            orderingDates: this.selectedLocation.delivery_time,
            deliveryPickupTime:
              this.selectedLocation.orderSetting.delivery_time,
          };
        case enumHelper.orderType.Collection:
          return {
            orderingDates: this.selectedLocation.pickup_time,
            deliveryPickupTime:
              this.selectedLocation.orderSetting.collection_time,
          };
      }
    },
    disabledDatePickerDates(date) {
      if (
        !this.laterDateTimeSettings ||
        !this.laterDateTimeSettings.orderingDates
      )
        return true;
      //8.64e7 : number of milliseconds of a day. We need to subtract the number from current timestamp so that we don't disable today

      if (date.getTime() < Date.now() - 8.64e7) return true;

      let local_date = new Date(date.getTime());
      let currentDay_moment = this.$moment(
        `${local_date.getDate()}/${
          local_date.getMonth() + 1
        }/${local_date.getFullYear()}`,
        "DD/MM/YYYY"
      );
      let currentDay = currentDay_moment.format("YYYY-MM-DD");

      let arrDays = Object.keys(this.laterDateTimeSettings.orderingDates);
      return !arrDays.includes(currentDay);
    },
    getDateTimeText(pickup) {
      if (pickup.type == enumHelper.PickupTime.ASAP)
        return this.$t("text.asap");
      if (!pickup.date || !pickup.time) return "";
      //console.log(pickup)
      return `${this.$t("text.later")} : ${helpers.generateFormatedDateTime(
        pickup.date,
        "date",
        "dddd DD MM YYYY",
        this.$i18n.locale
      )} ${helpers.generateFormatedDateTime(pickup.time, "time", "HH:mm")}`;
    },
    //*************************** End components Methods ****************************** */

    //*************************** Start Order Tracking Methods ****************************** */
    displayOrderTrack() {
      if (!this.orderCompleted || !this.orderCompleted.newOrder) return null;
      this.loadTracking = true;
      //--- get the order by ID
      this.fetchTrackingOrder({ order_id: this.orderCompleted.newOrder.id })
        .then((response) => {
          this.objOrderHistory = {
            id: response.data.id,
            where2_enabled: response.data.where2_enabled,
            location: response.data.location,
            orderWhere2: response.data.orderWhere2,
            order_type: response.data.order_type,
            order_status: response.data.order_status,
            orderStatusHistory: response.data.orderStatusHistory,
            proposed_ready_time:response.data.proposed_ready_time


          };
          this.$nextTick(() => {
            this.$refs.itemStatusModal.openModal();
          });
        })
        .finally(() => {
          this.loadTracking = false;
        });
    },
    //*************************** End Order Tracking Methods ****************************** */
    goToHome() {
      cartManager.clearCart();
      this.$nextTick(() => {
        router.push("/");
      });
    },

    goToMenu() {
      this.cart = cartManager.getCart();
      this.cart.status = enumHelper.status.PREPARED;
      this.cart.newOrder = null;
      this.cart.id = null;
      this.cart.step = enumHelper.steps.STEP01;
      this.cart.payment_type = enumHelper.paymentType.Card;
      this.cart.pickUp = {
        type: enumHelper.PickupTime.ASAP,
        date: null,
        time: null,
      };
      cartManager.setCart(this.cart, false, false);
      this.$nextTick(() => {
        router.push("/menu");
      });
    },

    redirectToLogin() {
      this.$router.push("/login");
    },
    isCardExpired(cardDetails) {
      if (!cardDetails) {
        return true;
      }
      let expiration = this.$moment(
        `${cardDetails.exp_month}/${cardDetails.exp_year}`,
        "MM/YYYY"
      );
      let now = this.$moment();
      return !now.isSameOrBefore(expiration, "month");
    },
    nativePaymentFailed() {
      this.processing = false;
    },
  },
  mounted() {
    this.isMounted = true;

    // if the cart is empty redirect the user to home page
    if (localStorage.getItem("saved-order") === "null") {
      if (
        helpers.controlAvailibilityBeforeCheckout(
          this.locationStatus,
          cartManager.getCart()
        )
      )
        this.$router.push("/");
    }

    this.cart.pickUp = {
      type: enumHelper.PickupTime.ASAP,
      date: null,
      time: null,
    };
    //--- prepare the interface for the pre-order
    if (
      !this.isLocationEmpty() &&
      this.cart.orderType != enumHelper.orderType.Table
    ) {
      this.laterDateTimeSettings = JSON.parse(
        JSON.stringify(this.getOrderSettingsByType())
      );
      if (
        (this.cart.orderType == enumHelper.orderType.Delivery &&
          !this.locationStatus.openingHours.delivery &&
          this.locationStatus.can_accept_delivery) ||
        (this.cart.orderType == enumHelper.orderType.Collection &&
          !this.locationStatus.openingHours.collection &&
          this.locationStatus.can_accept_collection)
      ) {
        this.cart.pickUp.type = enumHelper.PickupTime.LATER;
      }
    }

    if (this.cart && this.cart.orderType == enumHelper.orderType.Table)
      this.table_id = this.cart.table ? this.cart.table.id : null;

    if (this.cart && this.cart.orderType == enumHelper.orderType.Delivery) {
      this.address_id =
        this.cart.address && this.cart.address.id ? this.cart.address.id : null;
      if (this.cart.address && this.cart.address.postcode)
        this.checkTheDeliveryAddess();
    }

    if (this.isAuthenticated || this.guestData) {
      this.currentUser = this.isAuthenticated ? this.user : this.guestData;
      this.cart.user = {
        id: this.currentUser.id,
        email: this.currentUser.email,
        first_name: this.currentUser.first_name,
        last_name: this.currentUser.last_name,
        telephone_number: this.currentUser.telephone_number,
      };
    }
  },
  watch: {
    emailExist: {
      handler: function (newVal) {
        this.showEmailAlert = !!newVal;
      },
    },
  },
};
</script>

<style lang="scss">
.k-icon-sadface {
  font-size: 6.5rem;
}
.stripe-card {
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
.pickup-delivery,
.table-ordering,
.mode-payment {
  padding: 0 1.25rem 0.75rem 1.25rem;
}
.pickup-delivery p {
  font-size: 1em;
  margin: 0;
}
.pickup-delivery p.title {
  text-align: left;
  font-weight: 800;
  font-size: 1.1em;
  margin: 0;
  padding: 5px 0 5px 0;
}

.pickup-delivery .list-group-item,
.mode-payment .list-group-item {
  padding: 0;
  border: 0;
}
.pickup-delivery .btn-group,
.pickup-delivery label,
.mode-payment .form-check,
.mode-payment label,
.mode-payment .btn-group {
  width: 100%;
}
.pickup-delivery .form-check{
  padding-left: 0px !important;
}
.datepicker-container {
  padding-top: 1.25rem;
}
.section-steps-1 p {
  font-size: 1em;
}
.section-steps-1 p strong {
  font-weight: 600;
}

.section-steps-1 .p-login {
  font-weight: 600;
  font-size: 0.9em;
}
.stripe-card.form-control {
  border: 1px solid #e3e3e3 !important;
}

.section-steps-2 .stripeImg {
  width: 50%;
  margin: 5px;
  max-width: 170px;
}

.section-steps-2 .apple-pay-img {
  margin-top: 20px;
  max-width: 90px;
}
.section-steps-2 .google-pay-img {
  max-width: 120px;
}

.section-steps-3 {
  padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-date-table td.disabled div {
  opacity: 0.5 !important;
  filter: alpha(opacity=50) !important; /* For IE8 and earlier */
}
.el-date-table td.disabled div span {
  color: #c0c4cc !important;
}
.closed-days span:after {
  font: normal normal normal 12px/1 FontAwesome;
  content: "\F023";
  display: block;
  position: absolute;
  bottom: 6px;
  right: -2px;
}
.grid-payment {
  width: 100%;
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 70% 30%;
}
.grid-payment .grid-label {
  grid-column: 1;
}
.grid-payment .grid-value {
  grid-column: 2;
}
.grid-payment .grid-label,
.grid-payment .grid-value {
  font-size: 1.1rem;
  font-weight: 600;
  text-align: end;
}
.grid-payment .grid-label.green,
.grid-payment .grid-value.green {
  color: #009900;
}
.grid-payment .grid-label.red,
.grid-payment .grid-value.red {
  color: #ff0000;
}
.add-top-margin {
  margin-top: 10px !important;
}
.romove-left-right-padding {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.back-to-menu-link p {
  text-align: center;
}
.clear-selection {
  color: red !important;
  font-weight: 600;
}
.payment-type {
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  width: 100px;
  height: 100px;
  border-radius: 0.5rem;
  .active {
    font-size: 1.25rem;
  }
  .availale-mode {
    width: 100%;
    .icon {
      .el-image {
        height: 40px;
        margin-top: 10px;
      }
      i {
        font-size: 30px;
      }
      height: 60px;
      display: flex;
      justify-content: center;
      align-content: center;
    }
    .text {
      height: 40px;
      line-height: 40px;
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
      text-align: center;
    }
  }
}
.card-option {
  .card-icon {
    width: 40px;
  }
  .card-text {
    line-height: 40px;
    font-size: 13px;
    text-align: start;
    color: #606266;
  }
}
.card-step1 {
  max-width: 100%;
  margin: 0 auto;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;

  .el-input__prefix {
    .el-input__icon {
      line-height: 40px;
      float: right;
      padding-right: 30px;
    }
  }
}
.card-step2 {
  max-width: 100%;
  margin: 0 auto;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;

  .el-input__prefix {
    width: calc(100% - 40px);
  }
  .form-group .el-select .el-input__inner[readonly] {
    color: #fff !important;
  }
}
</style>
